import { FC } from "react";
import { RenderValue } from "../../HistoryTable/ProjectHistoryMapper";

import RightArrow from "../../../../assets/rightArrow.svg";
import { IProjectHistoryDisplay } from "../../../../common/api_interfaces/history/IProjectHistoryDisplay";

const MessageHistory: FC<{ projectLogs: IProjectHistoryDisplay[] }> = ({ projectLogs }) => (
    <div className="message-action-history">
        {projectLogs.map((log, logIndex) => 
            log.changeDataDifference.map((diff, diffIndex) => (
                <div
                    key={`history-${logIndex}-${diffIndex}`}
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        wordBreak: "break-word",
                        marginBottom: "5px",
                        alignItems: "center",
                    }}
                >
                    {diff.caption && (
                        <span
                            style={{
                                fontWeight: "bold",
                                fontSize: "medium",
                                marginRight: "5px",
                            }}
                        >
                            {diff.caption + ":"}
                        </span>
                    )}
                    
                    <RenderValue
                        type={diff.type}
                        value={diff.oldValue}
                        minimized={true}
                        showFullChanges={true}
                    />
                    
                    {(diff.oldValue || diff.newValue) && (
                        <img
                            style={{
                                alignSelf: "center",
                                margin: "0px 5px",
                            }}
                            src={RightArrow}
                            alt="arrow"
                            height={10}
                        />
                    )}
                    
                    <RenderValue
                        type={diff.type}
                        value={diff.newValue}
                        showFullChanges={true}
                        minimized={true}
                    />
                </div>
            ))
        )}
    </div>
);

export default MessageHistory;